import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Anexo21Y22RMF2026ProgramaInformatico() {
  return <CategoryPage category="anexo21Y22Rmf2026ProgramaInformatico" pageTitle="Programa Informatico 2026" />;
}

export default Anexo21Y22RMF2026ProgramaInformatico;
